var $70a475d19f826ca5$exports = {};
$70a475d19f826ca5$exports = {
    "actions": `A\xe7\xf5es`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Nenhum`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};


export {$70a475d19f826ca5$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
